import { ICreators, IMajor, IProfile } from '@/store/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface ICreatorDetailState {
  loading: boolean;
  creators?: ICreators;
}

const creatorsDetailSlice = createSliceSteamup(
  'creatorDetail',
  {
    loading: true,
    creators: undefined,
  } as ICreatorDetailState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.creators)>) {
      state.creators = payload;
    },
    setLongDescInit(state, { payload }: PayloadAction<string>) {
      if (state.creators) {
        state.creators.creator.longIntroduction = payload;
      }
    },
    setShortDescInit(state, { payload }: PayloadAction<string>) {
      if (state.creators) {
        state.creators.creator.shortIntroduction = payload;
      }
    },
    setFollow(state, { payload }: PayloadAction<boolean>) {
      if (state.creators) {
        state.creators.creator.hasFollow = payload;
      }
    },
    switchMajorContents(state, { payload }: PayloadAction<{targetUUID: string, targetIndex: number}>) {
      if (!state.creators) return;
      const { targetUUID, targetIndex } = payload;
      const currentIndex = state.creators.major.majorContent
        .findIndex(({ majorContentUUID }) => majorContentUUID === targetUUID);
      if (currentIndex < 0) return;

      const [item] = state.creators.major.majorContent.splice(currentIndex, 1);
      state.creators.major.majorContent = [
        ...state.creators.major.majorContent.slice(0, targetIndex),
        item,
        ...state.creators.major.majorContent.slice(targetIndex),
      ];
    },

    switchMajorClass(state, { payload }: PayloadAction<{targetUUID: string, targetIndex: number}>) {
      if (!state.creators) return;
      const { targetUUID, targetIndex } = payload;
      const currentIndex = state.creators.major.majorClass
        .findIndex(({ majorClassUUID }) => majorClassUUID === targetUUID);
      if (currentIndex < 0) return;

      const [item] = state.creators.major.majorClass.splice(currentIndex, 1);
      state.creators.major.majorClass = [
        ...state.creators.major.majorClass.slice(0, targetIndex),
        item,
        ...state.creators.major.majorClass.slice(targetIndex),
      ];
    },
  },
);

export default creatorsDetailSlice;
